import React from 'react';
import { Outlet } from 'react-router-dom';
import { Header } from './Header';
import { Sidebar } from './Sidebar';
import { SidebarProvider } from './SidebarContext';

export const Layout = () => {
  return (
    <SidebarProvider>
      <div className="min-h-screen lg:grid lg:grid-cols-[auto_1fr]">
        <Sidebar />
        <div className="flex flex-col min-h-screen bg-content-bg overflow-x-hidden">
          <Header />
          <main className="flex-1 container pl-6  pr-6 pt-4  w-full max-w-full">
            <Outlet />
          </main>
        </div>
      </div>
    </SidebarProvider>
  );
};
